export default {"src":"/_next/static/media/google_en.8759e5f0.svg","height":62,"width":192};